import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/auth/auth.service';

interface ResGetLearningCenterByIdI {
  success: boolean;
  result: any[];
  message: string;
}

interface ResGetAllLearningCenterI {
  success: boolean;
  result: any[];
  message: string;
}

interface ResGetLearningCenterThemeI {
  success: boolean;
  result: any[];
  message: string;
}

interface resGetTheme {
  success: boolean;
  message: string;
  result: theme[];
}

interface theme {
  THEME_ID: number;
  THEME_NAME: string;
  CONTENT2_BG: string;
  CONTENT3_TL_TX_CL: string;
  CONTENT3_CT_TX_CL: string;
  CONTENT3_BG: string;
  CONTENT2_BG_SD: string;
  CONTENT3_BG_SD: string;
}

interface ResCheckCenterNameAvailability {
  success: boolean;
  result: any;
  message: string;
}

interface ResLearningCenter {
  success: boolean;
  result: any;
  message: string;
}


@Injectable({
  providedIn: 'root',
})
export class LearningCenterManagementService {

  token: string = null;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  createLearningCenter(formData) {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.post<ResLearningCenter>(environment.URL + '/manage_admin/createLearningCenter', formData, { headers: headers })
  }

  getLearningCenter(CENTER_ID) {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.get<ResGetLearningCenterByIdI>(environment.URL + '/manage_admin/getLearningCenterById?CENTER_ID=' + CENTER_ID, { headers: headers })
  }

  getAllLearningCenter() {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.get<ResGetAllLearningCenterI>(environment.URL + '/manage_admin/getAllLearningCenterAdmin', { headers: headers })
  }

  getLearningCenterTheme() {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.get<ResGetLearningCenterThemeI>(environment.URL + '/manage_admin/getLearningTheme', { headers: headers })
  }

  updateLearningCenter(formData) {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.post<ResLearningCenter>(environment.URL + '/manage_admin/updateLearningCenter', formData, { headers: headers })
  }

  getLearningTheme() {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.get<resGetTheme>(environment.URL + '/manage_admin/getLearningTheme', { headers: headers })
  }

  checkCenterNameAvailability(data) {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.post<ResCheckCenterNameAvailability>(environment.URL + '/manage_admin/checkCenterNameAvailability', data, { headers: headers })
  }

  updateViewStatus(data) {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.post<ResLearningCenter>(environment.URL + '/manage_admin/updateViewStatus', data, { headers: headers })
  }

  deleteLearningCenter(data) {
    const headers = new HttpHeaders({ Authorization: this.token })
    return this.http.post<ResLearningCenter>(environment.URL + '/manage_admin/deleteLearningCenter', data, { headers: headers })
  }

}
